import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { User } from '@sentry/react';

interface UserFormProps {
  name: string;
  email: string;
  password: string;
  onNameChange: (v: string) => void;
  onEmailChange: (v: string) => void;
  onPasswordChange: (v: string) => void;
  onSubmit: () => void;
  isEdit?: boolean;
  setEditUser: (v: User | null) => void;
  disabled?: boolean;
}

export function UserForm({
  name,
  email,
  password,
  onNameChange,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  isEdit,
  setEditUser,
  disabled,
}: UserFormProps) {
  return (
    <form
      className="grid gap-4  w-full"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      {/* Linha 1: Nome e Email */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="userName">Nome</Label>
          <Input id="userName" value={name} onChange={(e) => onNameChange(e.target.value)} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="userEmail">Email</Label>
          <Input
            id="userEmail"
            type="email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
          />
        </div>
      </div>
      {/* Linha 2: Senha e Botão */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
        <div className="space-y-2">
          <Label htmlFor="userPassword">Senha</Label>
          <Input
            id="userPassword"
            type="password"
            value={password}
            onChange={(e) => onPasswordChange(e.target.value)}
          />
        </div>
        <div className="flex flex-row justify-center items-center">
          <Button disabled={disabled} type="submit" size="lg" className="w-full h-10 ">
            {isEdit ? 'Salvar Alterações' : 'Cadastrar Usuário'}
          </Button>
          {isEdit && (
            <Button variant="destructive" onClick={() => setEditUser(null)} className="ml-4 h-10">
              Cancelar Edição
            </Button>
          )}
        </div>
      </div>
    </form>
  );
}
